module.exports = __webpack_public_path__ + "static/media/WZ2.19fa5dd5.jpg";